import { z } from "zod";

export const OvertimeGuardHoursSchema = z.object({
  guardUserId: z.number().catch(0),
  name: z.string().catch(""),
  projectedHours: z.number().catch(0),
});

export const OvertimeWeeklyHoursSchema = z.object({
  weekStart: z.string().catch(""),
  weekEnd: z.string().catch(""),
  thresholdHours: z.number().catch(44),
  nearLimitHours: z.number().catch(4),
  guards: z.array(OvertimeGuardHoursSchema).catch([]),
});

export type OvertimeWeeklyHours = z.infer<typeof OvertimeWeeklyHoursSchema>;
export type OvertimeGuardHours = z.infer<typeof OvertimeGuardHoursSchema>;
